import { DeleteAndMustMoveFreeFieldCategory } from "components/modals/DeleteAndMustMoveItems";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import React from "react";

interface Props {
  optionsPanelData: server.dto.OptionsPanelDataV2
  listUrl: string
  freeFieldCategoryId: number
  mainArea: server.dto.MainAreas
}

const FreeFieldCategoryOptionsPanel = (props: Props) => {
  const [isDeleting, setIsDeleting] = React.useState<boolean>(false);

  return <>
    <GeneralOptionsPanel
      data={props.optionsPanelData}
      links={[
        {
          href: props.listUrl,
          text: RESX.Buttons.ListView,
          visible: true
        }, {
          onClick: () => { setIsDeleting(true); },
          text: RESX.Buttons.btnDelete,
          visible: true,
        }
      ]}
    />
    <DeleteAndMustMoveFreeFieldCategory
      freeFieldCategoryId={props.freeFieldCategoryId}
      afterDeleteRedirectUrl={props.listUrl}
      mainArea={props.mainArea}
      isOpen={isDeleting}
      onClose={() => { setIsDeleting(false); }}
    />
  </>;
};

export default FreeFieldCategoryOptionsPanel;